import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import SuperAdminLogin from './components/SuperAdminLogin';
import AccountPage from './components/AccountPage';
import SupportTicketDetails from './components/SupportTicketDetails';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('superAdminToken');
  return token ? children : <Redirect to="/login" />;
};

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/login" component={SuperAdminLogin} />
        <Route path="/dashboard" render={() => (
          <PrivateRoute>
            <SuperAdminDashboard />
          </PrivateRoute>
        )} />
        <Route path="/account/:accountId" render={(props) => (
          <PrivateRoute>
            <AccountPage {...props} />
          </PrivateRoute>
        )} />
        <Route path="/support/ticket/:ticketId" render={(props) => (
          <PrivateRoute>
            <SupportTicketDetails {...props} />
          </PrivateRoute>
        )} />
        <Route path="/" render={() => <Redirect to="/login" />} />
      </Switch>
    </Router>
  );
}

export default App;
